import { apiCaller } from "./metruyenvl_caller";


export const suggestAPI = {
    async postSuggestion(data: { book_id: string; point: number; }) {
        return apiCaller("/suggestion", "post", {
            header: {
                Authorization: ""
            }, body: {
                request: data
            }
        });
    },

    async getSuggestion(data: { book_id?: string; offset?: number; limit?: number; page?: number; page_size?: number; }) {
        return apiCaller("/suggestion", "get", {
            query: data
        });
    },
};